import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq.component.html'
})
export class FaqComponent {
  faqs = [
    {
      question: 'Wie vereinbare ich einen Termin?',
      answer: 'Sie können einfach über den Button "Termin vereinbaren" auf unserer Startseite einen passenden Termin bei einem verfügbaren Arzt wählen.',
      open: false
    },
    {
      question: 'Welche Kosten kommen auf mich zu?',
      answer: 'Die Kosten für eine telemedizinische Beratung werden Ihnen vor der Buchung transparent angezeigt.',
      open: false
    },
    {
      question: 'Wie erhalte ich mein Rezept?',
      answer: 'Nach einem erfolgreichen Gespräch stellt Ihnen der Arzt ein Rezept aus, welches Sie dann zugesendet bekommen, oder alternativ direkt bei uns einlösen können.',
      open: false
    },
    {
      question: 'Sind meine Daten sicher?',
      answer: 'Ja, wir nutzen modernste Verschlüsselungstechnologien und hosten alle Daten ausschließlich auf zertifizierten Servern in Deutschland.',
      open: false
    }
  ];

  toggleFaq(index: number) {
    this.faqs[index].open = !this.faqs[index].open;
  }
}
